// Literal localStorage/sessionStorage key names used across the app.
export const SESSION_CONSTANT = {
  TOKEN_KEY: "token",
  REFRESH_TOKEN_KEY: "refreshToken",
  TENANT_NEMENIC_KEY: "tenantNemonic",
  FEATURES_KEY: "features",
  FILTER_KEY: "FilterKey",
  USERNAME_KEY: "userName",
  WORKSPACE_SIDEBAR_COLLAPSED_KEY: "workspace-sidebar-collapsed",
  WORKSPACE_CALC_PANEL_COLLAPSED_KEY: "workspace-calc-panel-collapsed",
};
